import { combineReducers } from 'redux';

import { LOGOUT_USER_SUCCESS } from '../constants';
import accountReducer from './accountReducer';
import activeReducer from './activeReducer';
import adminReducer from './adminReducer';
import complianceReducer from './complianceReducer';
import dailyMetricsReducer from './dailyMetricsReducer';
import dailyParametersReducer from './dailyParametersReducer';
import errorReducer from './errorReducer';
import passiveParametersReducer from './passiveParametersReducer';
import patientsReducer from './patientsReducer';
import reportingReducer from './reportingReducer';
import settingsReducer from './settingsReducer';

const appReducer = combineReducers({
  account: accountReducer,
  patients: patientsReducer,
  dailyMetrics: dailyMetricsReducer,
  dailyParameters: dailyParametersReducer,
  passiveParameters: passiveParametersReducer,
  active: activeReducer,
  admin: adminReducer,
  compliance: complianceReducer,
  settings: settingsReducer,
  reporting: reportingReducer,
  error: errorReducer,
});

const rootReducer = (state: any, action: any) => {
  if (action.type === LOGOUT_USER_SUCCESS) {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default rootReducer;
